export default function Spotify() {
    return (
        <>
        <div className="rounded-lg w-full">
            <img alt="Spotify Recently Played" src="https://spotify-recently-played-readme.vercel.app/api?user=yude1119&amp;width=400" width="540" height="495" />
        </div>
        </>
    )
  }
  